import"./AspectRatio.css.ts.vanilla.css";var t={container:"AspectRatio_styles_container__t0egf90",ratioContainer:"AspectRatio_styles_ratioContainer__t0egf91",contentContainer:"AspectRatio_styles_contentContainer__t0egf92"};export{t as styles};
//# sourceMappingURL=AspectRatio.css.vanilla.js.map
